import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import axios from "axios";
import routes from "./routes.js";

const normalizeLocale = (lang) => {
  const code = lang?.split("-")[0];
  return ["en", "es"].includes(code) ? code : "en";
};

const router = createRouter({
  history: createWebHistory("/"),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

// Axios response interceptor for error handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        // Handle unauthorized access
        router.push("/log-in");
      }
    } else {
      // Handle other types of errors (e.g., network errors)
      console.error("An error occurred:", error.message);
    }
    return Promise.reject(error);
  },
);

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const saved = localStorage.getItem("user-locale");
  const browserLocale = normalizeLocale(navigator.language);
  const locale = saved || browserLocale;

  // Extract locale from the route if present
  const routeLocale = to.params.locale;

  // Redirect from root "/" to "/es" if Spanish is preferred
  if (to.path === "/" && locale === "es") {
    next("/es");
    return;
  }

  // If route is missing locale and user prefers Spanish, redirect to localized path
  if (!routeLocale && locale === "es" && to.path !== "/") {
    next(`/es${to.fullPath}`);
    return;
  }

  document.title = to.meta.title || "Biglo";

  // Store route locale if it exists
  if (routeLocale) {
    localStorage.setItem("user-locale", routeLocale);
  }

  // Auth guard (after locale check)
  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !store.getters["auth/isAuthenticated"]
  ) {
    next({
      path: `/${routeLocale || (locale === "es" ? "es" : "")}/log-in`,
      query: { redirect: to.fullPath },
    });
    return;
  }

  next();
});

export default router;
